module.exports = __webpack_public_path__ + "img/illustration-logIn.87eab0a0.svg";